<template>
  <div class="page" id="page-home" style="overflow: hidden;">
    <div class="section" id="section-home-landing" >
      <carousel
        :autoplay="false"
        :autoplayTimeout="5000"
        :items="1"
        :dots="false"
        :nav="false"
        :loop="true"
        ref="mainCarousel"
      >
        <div
          class="landing-carousel-item"
          v-for="n in 11"
          :key="n"
          :class="`main-${n}`"
        >
          <div class="carousel-content">
            <img alt="로고" src="/static/carousel-icon.png" />
            <h1>Careful management <br>and ongoing revitalization</h1>
            <p>{{ main[n % main.length].text }}</p>
            <a class="link-button" :href="main[n % main.length].href">
              <h3>{{ main[n % main.length].buttonText }}</h3>
            </a>
          </div> 
        </div>
      </carousel>
      
      <div class="carousel-nav">
        <button class="up" @click="carouselMove('prev', 'mainCarousel')">
          <img alt="이전 이미지로 이동" src="/static/btn_arrow_up.png" />
        </button>
        <button @click="carouselMove('next', 'mainCarousel')">
          <img alt="다음 이미지로 이동" src="/static/btn_arrow_down.png" />
        </button>
      </div>
    </div>

    <div class="section" id="section-home-about-us">
      <h1>ABOUT US</h1>
      <p>
        인슈넷에프씨는<br>
        37년 업력을 기반으로 13개 보험사에 대해 합리적이고<br>
        실용적인 보험비교서비스를 제공합니다.
      </p>
    </div>

    <div class="section" id="section-home-insurance-list">
      <div class="container">
        <div class="section-list">
          <h3>PRODUCTS</h3>
          <h1>보험상품</h1>
          <ul>
            <template v-for="(item, index, i) in insuranceIcon">
              <li :key="i" v-if="index < insurance_length">
                <div
                  class="container insurance-item"
                  @mouseenter="insuranceItemMouseOver(index)"
                  @mouseleave="insuranceItemMouseLeave(index)"
                >
                  <div class="container">
                    <router-link :to="{ name: 'CompareEstimate', query: { 'tab': item.name } }" >
                      <img
                        :src="item.src"
                        :width="item.width"
                        :height="item.height"
                        :ref="`insuranceIcon-${index}`"
                      />
                      <p>{{ item.name }}</p>
                    </router-link>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>
        <button class="section-button" @click="clickMore">
          {{ statusMore ? "접기" : "더보기" }}
          <i class="material-icons">{{ statusMore ? "remove" : "add" }}</i>
        </button>
      </div>
    </div>

    <div class="section" id="section-home-gifts">
      <div class="container">
        <div class="section-left">
          <img alt="6대 사은" src="/static/main/gift/gift.png" />
        </div>
        <div class="section-right">
          <h3>GIFTS</h3>
          <h1>6대 사은</h1>
          <div class="section-list">
            <ul>
              <li v-for="(item, i) in gifts" :key="i">
                <router-link :to="{ name: 'Gift', query: { 'tab': item.name } }">
                  <img :src="item.src" :width="item.width" :height="item.height">
                  <p>{{ item.name }}</p>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="section" id="section-home-guarantee">
      <div class="container">
        <div class="section-title">
          <h3>GUARANTEE</h3>
          <h1>5대 보증</h1>
        </div>
        <div class="section-list">
          <ul>
            <li v-for="(item, i) in guarantees" :key="i">
              <!--<img :src="item.src" ></img>-->
              <router-link :to="{ name: 'Guarantee', query: { 'tab': item.name } }">
                <img :src="item.src" :width="item.width" :height="item.height">
                <p>{{ item.name }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>
<script>
import carousel from 'vue-owl-carousel'
import Footer from "../../view/layout/Footer.vue"
import HomeAdModal from '@/components/Elements/HomeAdModal.vue';
export default {

  components: { carousel,Footer,HomeAdModal },
  data(){
    return {
      line: "/static/banner-line.png",
      insurance_length: 12,
      statusMore: false,
      main: [
        { text: '37년간 사랑받은 인슈넷FC의 혜택 6대 사은', href: '/gift?tab=24시간 주차알림', buttonText: '자세히 보기' },
        { text: '13개 보험사 전문적인 비교견적 합리적인 선택 인슈넷FC', href: '#section-home-insurance-list', buttonText: '비교견적 신청' },
        { text: '37년간 변함없이 고객 편에서 약속한 5대 보증', href: '/guarantee?tab=최저 보험료', buttonText: '자세히 보기' },
      ],
      insurances: [
        { name: "자동차보험", src: "/static/home-insurance-1.png", query: "자동차보험" },
        { name: "운전자보험", src: "/static/home-insurance-2.png", query: "운전자보험" },
        { name: "실손의료보험", src: "/static/home-insurance-3.png", query: "실손의료보험" },
        { name: "암/2대질병 보험", src: "/static/home-insurance-4.png", query: "암/2대질병 보험" },
        { name: "어린이보험", src: "/static/home-insurance-5.png", query: "어린이보험" },
        { name: "태아보험", src: "/static/home-insurance-6.png", query: "태아보험" },
        { name: "정기보험", src: "/static/home-insurance-7.png", query: "정기보험" },
        { name: "종신보험", src: "/static/home-insurance-8.png", query: "종신보험" },
        { name: "화재보험", src: "/static/home-insurance-9.png", query: "화재보험" },
        { name: "연금보험", src: "/static/home-insurance-10.png", query: "연금보험" },
        { name: "치아보험", src: "/static/home-insurance-11.png", query: "치아보험" },
        { name: "치매보험", src: "/static/home-insurance-12.png", query: "치매보험" },
        { name: "펫보험", src: "/static/home-insurance-13.png", query: "펫보험" },
      ],
      guarantees: [
        { name: "최저 보험료", src: "/static/main/guarantee/minimum.png", width: '59px', height: '63px' },
        { name: "청약철회 환불", src: "/static/main/guarantee/refund.png", width: '68px', height: '62px' },
        { name: "만기완결 알림", src: "/static/main/guarantee/alarm.png", width: '44px', height: '61px' },
        { name: "착오계약 리콜", src: "/static/main/guarantee/recall.png", width: '46px', height: '60px' },
        { name: "24시간 근무", src: "/static/main/guarantee/24hour.png", width: '60px', height: '61px' }
      ],
      gifts: [
        { name: "24시간 주차 알림", src: "/static/main/gift/parking.png", width: '60px', height: '60px' },
        { name: "긴급견인 20km 추가", src: "/static/main/gift/traction.png", width: '61px', height: '54px' },
        { name: "응급치료비 지원", src: "/static/main/gift/emergency.png", width: '54px', height: '51px' },
        { name: "4대 공개 게시판", src: "/static/main/gift/board.png", width: '54px', height: '61px' },
        { name: "SNS 보험정보", src: "/static/main/gift/sns.png", width: '51px', height: '55px' },
        { name: "12개 보험사 비교 견적", src: "/static/main/gift/estimate.png", width: '69px', height: '49px' },
      ],
      notice_data: [],
      openItem: -1,
      insuranceIcon: [
        { name: '자동차보험', src: '/static/main/icon/car_icon.png', activeSrc: '/static/main/icon/car_active_icon.png', width: '59px', height: '43px' },
        { name: '운전자보험', src: '/static/main/icon/driver_icon.png', activeSrc: '/static/main/icon/driver_active_icon.png', width: '52px', height: '56px' },
        { name: '실손의료보험', src: '/static/main/icon/medical_icon.png', activeSrc: '/static/main/icon/medical_active_icon.png', width: '53px', height: '53px' },
        { name: '암보험', src: '/static/main/icon/cancer_icon.png', activeSrc: '/static/main/icon/cancer_active_icon.png', width: '59px', height: '54px' },
        { name: '어린이보험', src: '/static/main/icon/children_icon.png', activeSrc: '/static/main/icon/children_active_icon.png', width: '68px', height: '57px' },
        { name: '태아보험', src: '/static/main/icon/fetal_icon.png', activeSrc: '/static/main/icon/fetal_active_icon.png', width: '58px', height: '55px' },
        { name: '정기보험', src: '/static/main/icon/term_icon.png', activeSrc: '/static/main/icon/term_active_icon.png', width: '60px', height: '62px' },
        { name: '종신보험', src: '/static/main/icon/whole_life_icon.png', activeSrc: '/static/main/icon/whole_life_active_icon.png', width: '57px', height: '59px' },
        { name: '화재보험', src: '/static/main/icon/fire_icon.png', activeSrc: '/static/main/icon/fire_active_icon.png', width: '58px', height: '57px' },
        { name: '연금보험', src: '/static/main/icon/pension_icon.png', activeSrc: '/static/main/icon/pension_active_icon.png', width: '61px', height: '61px' },
        { name: '치아보험', src: '/static/main/icon/dental_icon.png', activeSrc: '/static/main/icon/dental_active_icon.png', width: '55px', height: '53px' },
        { name: '치매보험', src: '/static/main/icon/demential_icon.png', activeSrc: '/static/main/icon/demential_active_icon.png', width: '38px', height: '60px' },
        { name: '펫보험', src: '/static/main/icon/pet_icon.png', activeSrc: '/static/main/icon/pet_active_icon.png', width: '52px', height: '46px' },
      ]
    }
  },
  created() {
    // location.href='/estimate/consultation'
    this.updatePage(1);

  },

  mounted(){
    // this.$refs.modalHomeAdModal.show();
  },
  methods: {
    navScroll(selector) {
      this.$smoothScroll({
        scrollTo: document.querySelector(selector),
        duration: 1000,
        offset: this.$store.state.config.isTouchDevice ? -70 : -98,
        updateHistory: false,
        //hash: '#nav-section',
        container: document.querySelector('body')
      })
      //location.replace('#' + scrollTo.id);
      this.$router.replace('#nav-section')
    },  
    clickMore(){
      if(!this.statusMore){
        this.insurance_length = 13;
        this.statusMore = true;
      }
      else{
        this.insurance_length = 12;
        this.statusMore = false;
      }
    },
    updatePage(page){
      this.$data.currentPage = page;
      // this.$store.dispatch( "post/getItems", { page: 1, size: 5, post_type: "notice" } ).then( res => {
      //   this.notice_data = res.data.data.items;
      // });

    },
    callNumber(){
      location.href = "tel:" + "16681100";
    },
    closeModal(){
      this.$refs.modalHomeAdModal.close();
    },
    test(){
      location.href="https://www.naver.com"
    },
    goEvent(){
      window.open('https://event.insunetfc.com/', '_blank');
    },
    carouselMove(type, refName) {
      const id = type === 'prev' ? 'prevHandler' : 'nextHandler';
      const $eId = this.$refs[refName];
      document.getElementById($eId[id]).click();
    },
    insuranceItemMouseOver(index) {
      const { activeSrc } = this.insuranceIcon[index];
      this.$refs[`insuranceIcon-${index}`][0].src = activeSrc;
    },
    insuranceItemMouseLeave(index) {
      const { src } = this.insuranceIcon[index];
      this.$refs[`insuranceIcon-${index}`][0].src = src;
    }
  }
}
</script>
<style lang="scss" scoped>
  .center.aligned {
    text-align: center;
  }
  a.link-button {
    border: 2px solid #174de5;
    padding: 0rem 1.5rem;
    font-size: 21px;
    font-weight: 400;
    border-radius: 4px;
    color: #174de5;
    display: inline-block;
    margin-top: 3rem;
  }
  a.event-button {
    border: 2px solid #44cc2f;
    background: #f0fff3;
    padding: 0rem 1.5rem;
    font-size: 21px;
    font-weight: 400;
    border-radius: 4px;
    color: #35af23;
    display: inline-block;
    margin-top: 3rem;
  }
</style>